module.exports = __webpack_public_path__ + "img/sm-nav-act.bf1c8ba2.png";